export var AgencyBillingTab;
(function (AgencyBillingTab) {
    AgencyBillingTab["SUBSCRIPTION"] = "subscriptions";
    AgencyBillingTab["WALLET_TRANSACTIONS"] = "wallet_transactions";
    AgencyBillingTab["PAYMENTS"] = "payments";
})(AgencyBillingTab || (AgencyBillingTab = {}));
export var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "active";
    CompanyStatus["ACTIVE_AUTO_CANCEL"] = "active_auto-cancel";
    CompanyStatus["ACTIVE_FAILED_PAYMENT"] = "active_failed-payment";
    CompanyStatus["ACTIVE_OVERUSED"] = "active_overused";
    CompanyStatus["ACTIVE_PAUSED"] = "active_paused";
    CompanyStatus["ACTIVE_SPECIAL"] = "active_special";
    CompanyStatus["ACTIVE_TEST_AGENCY"] = "active_test-agency";
    CompanyStatus["ACTIVE_TRIAL"] = "active_trial";
    CompanyStatus["ACTIVE_TRIAL_EXTENSION"] = "active_trial-extension";
    CompanyStatus["INACTIVE"] = "inactive";
    CompanyStatus["INACTIVE_AUTO_CANCELLED"] = "inactive_auto-cancelled";
    CompanyStatus["INACTIVE_BILLING_ERROR"] = "inactive_billing-error";
    CompanyStatus["INACTIVE_CANCELLED"] = "inactive_cancelled";
    CompanyStatus["INACTIVE_FAILED_PAYMENT"] = "inactive_failed-payment";
    CompanyStatus["INACTIVE_FORCE_CANCELLED"] = "inactive_force-cancelled";
    CompanyStatus["INACTIVE_PAUSED"] = "inactive_paused";
})(CompanyStatus || (CompanyStatus = {}));
export var PlanLabel;
(function (PlanLabel) {
    PlanLabel["AGENCY_ANNUAL_497"] = "agency_annual_497";
    PlanLabel["AGENCY_MONTHLY_497"] = "agency_monthly_497";
    PlanLabel["AGENCY_ANNUAL_297"] = "agency_annual_297";
    PlanLabel["AGENCY_MONTHLY_297"] = "agency_monthly_297";
    PlanLabel["AGENCY_MONTHLY_297_DIRECT"] = "agency_monthly_297_direct";
    PlanLabel["AGENCY_MONTHLY_297_MANUAL"] = "agency_monthly_297_manual";
    PlanLabel["AGENCY_ANNUAL_97"] = "agency_annual_97";
    PlanLabel["AGENCY_MONTHLY_97"] = "agency_monthly_97";
    PlanLabel["AGENCY_MONTHLY_237_LVRG"] = "agency_monthly_237_LVRG";
    PlanLabel["AGENCY_ANNUAL_237_LVRG"] = "agency_annual_237_LVRG";
    PlanLabel["AGENCY_MONTHLY_0_PLATFORM"] = "agency_monthly_0_platform";
    PlanLabel["AGENCY_MONTHLY_199_PLATFORM"] = "agency_monthly_199_platform";
    PlanLabel["AGENCY_MONTHLY_249_DIRECT"] = "agency_monthly_249_direct";
    PlanLabel["AGENCY_MONTHLY_300_DIRECT"] = "agency_monthly_300_direct";
    PlanLabel["AGENCY_MONTHLY_299_DIRECT"] = "agency_monthly_299_direct";
    PlanLabel["AGENCY_DAY_97"] = "agency_day_97";
})(PlanLabel || (PlanLabel = {}));
export var AddonLabel;
(function (AddonLabel) {
    AddonLabel["REVIEWS_MONTHLY_150"] = "reviews_monthly_150";
    AddonLabel["LISTING_MONTHLY_50"] = "listing_monthly_50";
    AddonLabel["CONVERSATIONS_MONTHLY_100"] = "conversations_monthly_100";
    AddonLabel["PRIORITY_SUPPORT_MONTHLY_300"] = "priority-support_monthly_300";
    AddonLabel["PRIORITY_SUPPORT_ANNUAL_300"] = "priority-support_annual_300";
    AddonLabel["PRIORITY_SUPPORT_MONTHLY_300_LEGACY"] = "priority-support_monthly_300_legacy";
    AddonLabel["PRIORITY_SUPPORT_ANNUAL_300_LEGACY"] = "priority-support_annual_300_legacy";
    AddonLabel["PRIORITY_SUPPORT_MONTHLY_240_JULY"] = "priority-support_monthly_240_july";
    AddonLabel["HIPAA_MONTHLY_297"] = "hipaa_monthly_297";
    AddonLabel["HIPAA_ANNUAL_297"] = "hipaa_annual_297";
    AddonLabel["HIPAA_MONTHLY_297_LEGACY"] = "hipaa_monthly_297_legacy";
    AddonLabel["AGENCY_PRO_PLUS_MONTHLY_399"] = "agency-pro-plus_monthly_399";
    AddonLabel["AGENCY_PRO_PLUS_ANNUAL_399"] = "agency-pro-plus_annual_399";
    AddonLabel["WL_MOBILE_MONTHLY_497"] = "wl-mobile_monthly_497";
    AddonLabel["WL_MOBILE_ANNUAL_497"] = "wl-mobile_annual_497";
    AddonLabel["ELIZA_MONTHLY_500"] = "eliza_monthly_500";
    AddonLabel["ELIZA_ANNUAL_500"] = "eliza_annual_500";
})(AddonLabel || (AddonLabel = {}));
export var BundleLabel;
(function (BundleLabel) {
    BundleLabel["BUILDER_BUNDLE_MONTHLY_1094"] = "builder-bundle_monthly_1094";
    BundleLabel["BUILDER_BUNDLE_ANNUAl_1094"] = "builder-bundle_annual_1094";
    BundleLabel["ELIZA_BUNDLE_MONTHLY_1594"] = "eliza-bundle_monthly_1594";
    BundleLabel["ELIZA_BUNDLE_ANNUAL_1594"] = "eliza-bundle_annual_1594";
})(BundleLabel || (BundleLabel = {}));
export var AddonType;
(function (AddonType) {
    AddonType["REVIEWS"] = "reviews";
    AddonType["LISTING"] = "listing";
    AddonType["CONVERSATIONS"] = "conversations";
    AddonType["PRIORITY_SUPPORT"] = "priority-support";
    AddonType["HIPAA"] = "hipaa";
    AddonType["AGENCY_PRO_PLUS"] = "agency-pro-plus";
    AddonType["ELIZA"] = "eliza";
    AddonType["WL_MOBILE"] = "wl-mobile";
})(AddonType || (AddonType = {}));
export const StripeAppearanceConfig = {
    variables: {
        fontFamily: 'Inter, system-ui, sans-serif',
        colorPrimary: '#155EEF',
        colorDanger: '#D92D20',
        colorText: '#101828',
        borderRadius: '8px',
        spacingGridRow: '16px',
        spacingGridColumn: '16px',
    },
    rules: {
        '.Input': {
            border: '1px solid #D0D5DD',
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
            padding: '10px 10px 10px 14px',
        },
        '.Input:hover': {
            border: '1px solid #155EEF',
        },
        '.Input:focus': {
            border: '1px solid #155EEF',
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        },
        '.Input--invalid': {
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        },
        '.Input--invalid:hover': {
            border: '1px solid #B42318',
        },
        '.Input--invalid:focus': {
            border: '1px solid #B42318',
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        },
        '.Label': {
            fontSize: '14px',
            color: '#344054',
            fontWeight: 500,
            lineHeight: '20px',
            marginBottom: '6px',
            textTransform: 'capitalize',
        },
        '.Error': {
            fontSize: '14px',
        },
    },
};
export const WordpressPlan = {
    FOUNDER_SPECIAL: {
        planPrice: 3000,
        planCycle: 'annual',
        planString: "Founder's Special Offer",
    },
    UNLIMITED_MONTHLY: {
        planPrice: 350,
        planCycle: 'monthly',
        planString: 'Unlimited Monthly Plan',
    },
    UNLIMITED_YEARLY: {
        planPrice: 3500,
        planCycle: 'annual',
        planString: 'Unlimited Yearly Plan',
    },
};
export var StripeChargeStatus;
(function (StripeChargeStatus) {
    StripeChargeStatus["SUCCEEDED"] = "succeeded";
    StripeChargeStatus["FAILED"] = "failed";
    StripeChargeStatus["PENDING"] = "pending";
})(StripeChargeStatus || (StripeChargeStatus = {}));
export var StripeInvoiceStatus;
(function (StripeInvoiceStatus) {
    StripeInvoiceStatus["DRAFT"] = "draft";
    StripeInvoiceStatus["OPEN"] = "open";
    StripeInvoiceStatus["VOID"] = "void";
    StripeInvoiceStatus["PAID"] = "paid";
    StripeInvoiceStatus["UNCOLLECTIBLE"] = "uncollectible";
})(StripeInvoiceStatus || (StripeInvoiceStatus = {}));
export var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus["TRIALING"] = "trialing";
    StripeSubscriptionStatus["ACTIVE"] = "active";
    StripeSubscriptionStatus["PAST_DUE"] = "past_due";
})(StripeSubscriptionStatus || (StripeSubscriptionStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["SUCCEEDED"] = "Succeeded";
    PaymentStatus["FAILED"] = "Failed";
    PaymentStatus["REFUNDED"] = "Refunded";
    PaymentStatus["PARTIAL_REFUNDED"] = "Partial refund";
    PaymentStatus["CANCELED"] = "Canceled";
    PaymentStatus["PENDING"] = "Pending";
})(PaymentStatus || (PaymentStatus = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PAID"] = "Paid";
    InvoiceStatus["VOID"] = "Void";
    InvoiceStatus["DRAFT"] = "Draft";
    InvoiceStatus["RETRYING"] = "Retrying";
    InvoiceStatus["FAILED"] = "Failed";
    InvoiceStatus["OPEN"] = "Open";
})(InvoiceStatus || (InvoiceStatus = {}));
export var SupportHomepageTab;
(function (SupportHomepageTab) {
    SupportHomepageTab["BILLING"] = "billing";
    SupportHomepageTab["WALLET_TRANSACTIONS"] = "wallet_transactions";
    SupportHomepageTab["INFO"] = "info";
})(SupportHomepageTab || (SupportHomepageTab = {}));
export var TaxVerificationStatus;
(function (TaxVerificationStatus) {
    TaxVerificationStatus["PENDING"] = "pending";
    TaxVerificationStatus["VERIFIED"] = "verified";
    TaxVerificationStatus["UNVERIFIED"] = "unverified";
})(TaxVerificationStatus || (TaxVerificationStatus = {}));
